export const STOCKOUT_SUMMARY_COLUMNS = [
  { key: "stockout_id", label: "Stockout ID" },
  { key: "date", label: "Date" },
  { key: "upline_name", label: "Upline Name" },
  { key: "product", label: "Product" },
  { key: "count", label: "Count" },
  { key: "downline_name", label: "Downline Name" },
  { key: "receive_date", label: "Receive Date" },
  { key: "receive_status", label: "Receive Status" },
  { key: "remark", label: "Remark" },
];
